import { b as __awaiter, L as LogKey, c as __generator, S as SOCKET_EVENT, T as TimeoutNatChannelError, N as NCHAT_CHANNEL_TIMEOUT_MS, e as N_CHAT_CHANNEL, U as UnexpectedSessionIOError, M as MAX_CONNECT_RETRY_TIMEOUT_MS, C as ChannelName } from './constant-89e708bf.js';
import { DeferredPromise, sleep } from '@financial/common-utils';
import axios from 'axios';
import { nanoid } from 'nanoid';
import io from 'socket.io-client';

var TaskType;
(function (TaskType) {
    TaskType["AssetList"] = "AssetList";
    TaskType["AssetDetail"] = "AssetDetail";
    TaskType["AssetStatementList"] = "AssetStatementList";
    TaskType["CardBillList"] = "CardBillList";
    TaskType["CardPoint"] = "CardPoint";
    TaskType["CardLoan"] = "CardLoan";
    TaskType["AccountScheduled"] = "AccountScheduled";
    TaskType["TelecomBill"] = "TelecomBill";
    TaskType["Pfms"] = "Pfms";
    TaskType["Pfms2"] = "Pfms2";
    /**
     * @deprecated
     */
    TaskType["PfmsAsset"] = "AssetsForPfms";
    TaskType["PfmsAsset2"] = "AssetsForPfms2";
    TaskType["TaskTimeout"] = "TaskTimeout";
})(TaskType || (TaskType = {}));

var SessionIo = /** @class */ (function () {
    function SessionIo(fetchConnectionInfo, _a) {
        var _b = _a.retryCount, _retryCount = _b === void 0 ? Number.MAX_SAFE_INTEGER : _b, _retryTimeout = _a.retryTimeout, _c = _a.debug, debug = _c === void 0 ? false : _c;
        this.fetchConnectionInfo = fetchConnectionInfo;
        this.taskListenerInfo = {};
        /**
         * @description 초기화 되었는지 여부
         */
        this.initialized = false;
        /**
         * @description 초기화 중인지 여부
         */
        this.initializing = false;
        this.deferredInitialized = new DeferredPromise();
        this.deferredNaverIdSet = new DeferredPromise();
        this.connectedSocket = null;
        this.naverId = '';
        this.debugMode = false;
        this.uuid = '';
        this.retryCount = _retryCount;
        this.retryTimeout = _retryTimeout;
        this.debugMode = debug;
    }
    SessionIo.prototype.connectSessionIo = function (channelName) {
        return __awaiter(this, void 0, void 0, function () {
            var url, socket;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.connectedSocket) === null || _a === void 0 ? void 0 : _a.disconnect();
                        this.connectedSocket = null;
                        return [4 /*yield*/, this.fetchConnectionInfo(channelName)];
                    case 1:
                        url = (_b.sent()).url;
                        socket = io.connect(url, {
                            // 가이드 옵션
                            // https://pages.oss.navercorp.com/nchat/Docs/quick-start/connect/#%EC%98%B5%EC%85%98-%EC%84%A4%EC%A0%95
                            // 생성된 URL은 임의의 시간동안 한번만 유효하기 떄문에 재접속시도 로직은 직전 구현이 필요
                            // https://pages.oss.navercorp.com/nchat/Docs/quick-start/get-authorization/#response
                            reconnection: false,
                            forceNew: true,
                            timeout: 3000,
                            transports: ['websocket'],
                        });
                        this.connectedSocket = socket;
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                socket.once(SOCKET_EVENT.CONNECT, resolve);
                                socket.once(SOCKET_EVENT.CONNECT_ERROR, reject);
                            })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, socket];
                }
            });
        });
    };
    SessionIo.prototype.subscribeChannel = function (socket, channelName) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var timeoutId = setTimeout(function () {
                                reject(new TimeoutNatChannelError());
                            }, NCHAT_CHANNEL_TIMEOUT_MS);
                            socket.on(N_CHAT_CHANNEL, function (data) {
                                try {
                                    var _a = JSON.parse(data), code = _a.code, result = _a.result;
                                    _this.logging(LogKey.SessionIOSubscribeResponse, { code: code, result: result, data: data });
                                    if (code === 200) {
                                        resolve();
                                    }
                                    else {
                                        throw new UnexpectedSessionIOError(result.toString());
                                    }
                                }
                                catch (e) {
                                    reject(e);
                                }
                                finally {
                                    clearTimeout(timeoutId);
                                }
                            });
                            socket.emit(N_CHAT_CHANNEL, {
                                command: 'subscribe',
                                name: {
                                    channels: ["".concat(channelName, "-").concat(_this.naverId)],
                                },
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SessionIo.prototype.connectWithRetry = function (channelName) {
        return __awaiter(this, void 0, void 0, function () {
            var retryCount, socket, e_1, retryTimeoutMs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retryCount = 0;
                        _a.label = 1;
                    case 1:
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 7]);
                        return [4 /*yield*/, this.connectSessionIo(channelName)];
                    case 3:
                        socket = _a.sent();
                        return [4 /*yield*/, this.subscribeChannel(socket, channelName)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, socket];
                    case 5:
                        e_1 = _a.sent();
                        retryCount += 1;
                        this.logging(LogKey.SessionIORetry, "".concat(retryCount, "/").concat(this.retryCount, " \uC7AC\uC2DC\uB3C4 \uC911"));
                        // 재시도 횟수 초과시 (== sessionInfo를 가져오지 못하거나 실패할 경우) 에러를 던진다.
                        if (retryCount > this.retryCount) {
                            throw e_1;
                        }
                        retryTimeoutMs = this.retryTimeout || Math.pow(2, retryCount - 1) * 1000 // 2^0, 2^1 ...
                        ;
                        return [4 /*yield*/, sleep(Math.min(retryTimeoutMs, MAX_CONNECT_RETRY_TIMEOUT_MS))];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 1];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SessionIo.prototype.publish = function (response) {
        var taskId = response.taskId;
        if (taskId && this.taskListenerInfo[taskId]) {
            this.taskListenerInfo[taskId].forEach(function (taskListener) {
                taskListener(response);
            });
        }
    };
    SessionIo.prototype.waitUntilInitialized = function () {
        return this.deferredInitialized;
    };
    SessionIo.prototype.waitUntilNaverIdSet = function () {
        return this.deferredNaverIdSet;
    };
    SessionIo.prototype.setNaverId = function (naverId) {
        this.naverId = naverId;
        this.deferredNaverIdSet.resolve();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    SessionIo.prototype.logging = function (key) {
        var _a;
        var info = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            info[_i - 1] = arguments[_i];
        }
        try {
            if (!this.debugMode) {
                return;
            }
            var logInfo = {
                naverId: this.naverId,
                url: window.location.pathname,
                uuid: this.uuid,
                datetime: new Date().getTime(),
            };
            if (!window.__MYDATA_UPDATER_LOG__) {
                window.__MYDATA_UPDATER_LOG__ = [];
            }
            var logData = (_a = {},
                _a[key] = {
                    logInfo: logInfo,
                    info: info,
                },
                _a);
            window.__MYDATA_UPDATER_LOG__.push(logData);
            axios.post('/mydata/ext-api/updater/log', logData);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.log('failed to logging data', e);
        }
    };
    SessionIo.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var uuid, socket;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.initializing || this.initialized) {
                            return [2 /*return*/];
                        }
                        this.initializing = true;
                        return [4 /*yield*/, this.waitUntilNaverIdSet()];
                    case 1:
                        _a.sent();
                        uuid = nanoid();
                        this.uuid = uuid;
                        this.logging(LogKey.SessionIOInitialized, this.naverId);
                        return [4 /*yield*/, this.connectWithRetry(ChannelName)
                            // session.io 응답
                        ];
                    case 2:
                        socket = _a.sent();
                        // session.io 응답
                        socket.on(SOCKET_EVENT.SEND, function (sessionIoResponse) {
                            _this.logging(LogKey.SessionIOResponse, sessionIoResponse);
                            _this.publish(sessionIoResponse);
                        });
                        // 서버에서 연결이 끊기는 경우
                        socket.on(SOCKET_EVENT.DISCONNECT, function (reason) {
                            _this.logging(LogKey.SessionIODisconnected, reason);
                            if (reason !== 'io client disconnect') {
                                _this.init();
                            }
                        });
                        this.initializing = false;
                        this.initialized = true;
                        this.deferredInitialized.resolve();
                        return [2 /*return*/, this.uuid];
                }
            });
        });
    };
    SessionIo.prototype.subscribe = function (taskId, listener, timeoutMs) {
        var _this = this;
        if (timeoutMs === void 0) { timeoutMs = 1000 * 30; }
        // timeoutMs 동안 taskListener 함수가 실행이 안되면, 자체적으로 publish 한다.
        var taskListenerTimeoutId = setTimeout(function () {
            _this.logging(LogKey.SessionIOTaskTimeout, { taskId: taskId, type: TaskType.TaskTimeout });
            _this.publish({ taskId: taskId, type: TaskType.TaskTimeout });
        }, timeoutMs);
        var unsubscribe = function (taskListener) {
            _this.taskListenerInfo[taskId] = _this.taskListenerInfo[taskId].filter(function (_taskListener) { return _taskListener !== taskListener; });
            if (_this.taskListenerInfo[taskId].length === 0) {
                delete _this.taskListenerInfo[taskId];
            }
        };
        // session.io 응답이 오면 publish 에 의해 실행되는 함수.
        // subscribe 한 리스너를 실행하고, 즉시 unsubscribe 한다.
        var taskListener = function (result) {
            _this.logging(LogKey.SessionIOTaskSubscribeResponse, result);
            clearTimeout(taskListenerTimeoutId);
            listener(result);
            unsubscribe(taskListener);
        };
        if (!this.taskListenerInfo[taskId]) {
            this.taskListenerInfo[taskId] = [];
        }
        this.taskListenerInfo[taskId].push(taskListener);
        this.logging(LogKey.SessionIOTaskListenerInfo, this.taskListenerInfo);
        return function () {
            clearTimeout(taskListenerTimeoutId);
            unsubscribe(taskListener);
        };
    };
    return SessionIo;
}());

export { SessionIo as S, TaskType as T };
